import { colors } from '@beelday/common'
import styled from '@emotion/styled'
import { FC, ReactNode } from 'react'

const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

const Faces = styled.span`
	display: flex;

	/* Each face overlaps the one before it. */
	& > * + * {
		margin-left: -8px;
	}
`

const Face = styled.span`
	box-sizing: border-box;
	width: 28px;
	height: 28px;
	overflow: hidden;
	border: 2px solid ${colors.white};
	border-radius: 50%;
	background: ${colors.white};
`

const More = styled(Face)`
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${colors.indigoBlue10};
	color: ${colors.indigoBlue};
	font-size: 11px;
	font-weight: 700;
`

const Count = styled.span`
	color: ${colors.blackish};
	font-size: 14px;
	font-weight: 500;
`

type Props = {
	/** Up to a handful of avatars. Decorative: the count says it. */
	faces: ReactNode[]
	/** How many people there are beyond the faces. */
	more: number
}

/** "3 of 5 in the room", with the faces of some of them. */
export const LobbyAttendance: FC<Props> = ({ faces, more, children }) => (
	<Row data-testid="in_person.lobby.attendance">
		{faces.length > 0 ? (
			<Faces aria-hidden="true">
				{faces.map((face, index) => (
					<Face key={index}>{face}</Face>
				))}
				{more > 0 ? <More>+{more}</More> : null}
			</Faces>
		) : null}
		<Count>{children}</Count>
	</Row>
)
